module.exports = __webpack_public_path__ + "media/a2.0fe401ad.wav";